import styled from 'styled-components';
import { SubEvents_People } from 'src/graphql/schema.graphql';
import { media } from 'src/styles/designs';
import { Avatar } from 'src/modules/user/components/Avatar';
import { dirRTL } from 'src/styles/theme';

export interface EventPageAgendaTimeslotSpeakersProps {
  speakers: SubEvents_People[];
}

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px 20px;
  max-width: max-content;

  margin-top: 12px;

  ${media.w.greaterThanOrEqual.desktop} {
    grid-template-columns: repeat(2, min-content);
  }
`;

const SpeakerItem = styled.div`
  display: flex;
  align-items: center;
  ${media.w.greaterThanOrEqual.desktop} {
    white-space: nowrap;
  }
`;

const StyledAvatar = styled(Avatar)`
  height: 40px;
  min-width: 40px;
`;

const Name = styled.p`
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.text.palette.secondary};
  margin: 0 0 0 8px;
  ${dirRTL} {
    margin: 0 8px 0 0;
  }
`;

export const EventPageAgendaTimeslotSpeakers = ({
  speakers,
}: EventPageAgendaTimeslotSpeakersProps) => {
  return (
    <Container>
      {speakers.map((speaker) => (
        <SpeakerItem key={speaker.people_id.name}>
          <StyledAvatar src={speaker.people_id.avatar?.id} />
          <Name>{speaker.people_id.name}</Name>
        </SpeakerItem>
      ))}
    </Container>
  );
};
